import { Action, createReducer, on } from '@ngrx/store';
import * as fromPaymentsAndStatementsActions from '../actions';

export const paymentDayFeatureKey = 'paymentDay';

export interface State {
  loaded: boolean;
  error?: Error | any;
  day: string;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  day: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromPaymentsAndStatementsActions.loadPaymentDay, fromPaymentsAndStatementsActions.loadAddPaymentDay, state => state),
  on(fromPaymentsAndStatementsActions.loadPaymentDaySuccess, (state, action) => ({ ...state, day: action.response, loaded: true })),

  on(
    fromPaymentsAndStatementsActions.loadPaymentDayFailure,
    fromPaymentsAndStatementsActions.loadAddPaymentDayFailure,
    (state, { error }) => ({
      ...state,
      error
    })
  )
);

export const selectPaymentDay = (state: State) => state.day;
export const selectPaymentDayLoaded = (state: State) => state.loaded;
export const selectPaymentDayError = (state: State) => state.error;
